(() => {
  const SHOE_OPTION_NAMES = new Set([
    'shoe size','tamanho do sapato','tamanho de sapato','talla de zapato',
    'tamano de zapato','pointure','schuhgrosse','schuhgröße','schuhgroesse',
    'taglia scarpe','numero scarpa'
  ]);

  const CONVERSIONS = {
    '34': { US: '3',  UK: '1',  AU: '3',  BR: '32' },
    '35': { US: '4',  UK: '2',  AU: '4',  BR: '33' },
    '36': { US: '5',  UK: '3',  AU: '5',  BR: '34' },
    '37': { US: '6',  UK: '4',  AU: '6',  BR: '35' },
    '38': { US: '7',  UK: '5',  AU: '7',  BR: '36' },
    '39': { US: '8',  UK: '6',  AU: '8',  BR: '37' },
    '40': { US: '9',  UK: '7',  AU: '9',  BR: '38' },
    '41': { US: '10', UK: '8',  AU: '10', BR: '39' },
    '42': { US: '11', UK: '9',  AU: '11', BR: '40' },
    '43': { US: '12', UK: '10', AU: '12', BR: '41' }
  };

  const COPY = {
    en: {
      guide: 'Size guide',
      shoeHeading: 'Shoe size',
      available: 'Available sizes',
      marketFor: 'Sizing for',
      yourSize: 'Your size',
      supplierSize: 'EU / supplier',
      how: 'How to measure',
      step1: 'Place a sheet of paper on a hard floor and stand on it with your weight evenly balanced.',
      step2Metric: 'Mark the heel and the tip of your longest toe, then measure the distance in centimetres.',
      step2Imperial: 'Mark the heel and the tip of your longest toe, then measure the distance in inches (or centimetres).',
      step3: 'Measure both feet and use the longer measurement. If you are between sizes, choose the next size up.',
      fitTitle: 'Fit & conversion note',
      shoeNote: 'International size conversions are a guide. We keep the original EU supplier size linked to your selection so the correct variant is added to cart. Fit can vary slightly by model and supplier.',
      apparelNote: 'Fit can vary by style and supplier. Use the product fit notes when available and measure your body before ordering.',
      bust: 'Bust — measure around the fullest part of your bust.',
      waist: 'Waist — measure around your natural waistline.',
      hips: 'Hips — measure around the fullest part of your hips.',
      localHint: 'The buttons show the sizing system used for your current market.',
      close: 'Close'
    },
    pt: {
      guide: 'Guia de tamanhos',
      shoeHeading: 'Tamanho do calçado',
      available: 'Tamanhos disponíveis',
      marketFor: 'Tamanhos para',
      yourSize: 'O teu tamanho',
      supplierSize: 'UE / fornecedor',
      how: 'Como medir',
      step1: 'Coloca uma folha de papel num chão duro e fica de pé sobre ela, com o peso distribuído de forma uniforme.',
      step2Metric: 'Marca o calcanhar e a ponta do dedo mais comprido e mede a distância em centímetros.',
      step2Imperial: 'Marca o calcanhar e a ponta do dedo mais comprido e mede a distância em polegadas (ou centímetros).',
      step3: 'Mede os dois pés e usa a medida do maior. Se estiveres entre dois tamanhos, escolhe o tamanho acima.',
      fitTitle: 'Nota sobre ajuste e conversão',
      shoeNote: 'As conversões internacionais são indicativas. Mantemos internamente o tamanho UE original do fornecedor ligado à tua escolha para adicionar a variante correta ao carrinho. O ajuste pode variar ligeiramente entre modelos e fornecedores.',
      apparelNote: 'O ajuste pode variar consoante o modelo e o fornecedor. Consulta as indicações do produto quando existirem e mede o corpo antes de comprar.',
      bust: 'Peito — mede à volta da zona mais larga do peito.',
      waist: 'Cintura — mede à volta da cintura natural.',
      hips: 'Ancas — mede à volta da zona mais larga das ancas.',
      localHint: 'Os botões mostram o sistema de tamanhos usado no mercado selecionado.',
      close: 'Fechar'
    },
    es: {
      guide: 'Guía de tallas',
      shoeHeading: 'Talla de calzado',
      available: 'Tallas disponibles',
      marketFor: 'Tallas para',
      yourSize: 'Tu talla',
      supplierSize: 'UE / proveedor',
      how: 'Cómo medir',
      step1: 'Coloca una hoja de papel sobre un suelo duro y ponte de pie sobre ella con el peso repartido de forma uniforme.',
      step2Metric: 'Marca el talón y la punta del dedo más largo y mide la distancia en centímetros.',
      step2Imperial: 'Marca el talón y la punta del dedo más largo y mide la distancia en pulgadas (o centímetros).',
      step3: 'Mide ambos pies y utiliza la medida del más largo. Si estás entre dos tallas, elige la talla superior.',
      fitTitle: 'Nota de ajuste y conversión',
      shoeNote: 'Las conversiones internacionales son orientativas. Conservamos internamente la talla UE original del proveedor vinculada a tu selección para añadir la variante correcta al carrito. El ajuste puede variar ligeramente según el modelo y el proveedor.',
      apparelNote: 'El ajuste puede variar según el modelo y el proveedor. Consulta las indicaciones del producto cuando estén disponibles y mídete antes de comprar.',
      bust: 'Pecho — mide alrededor de la parte más ancha del pecho.',
      waist: 'Cintura — mide alrededor de tu cintura natural.',
      hips: 'Cadera — mide alrededor de la parte más ancha de la cadera.',
      localHint: 'Los botones muestran el sistema de tallas utilizado en tu mercado actual.',
      close: 'Cerrar'
    },
    fr: {
      guide: 'Guide des tailles',
      shoeHeading: 'Pointure',
      available: 'Tailles disponibles',
      marketFor: 'Tailles pour',
      yourSize: 'Votre taille',
      supplierSize: 'UE / fournisseur',
      how: 'Comment mesurer',
      step1: 'Placez une feuille de papier sur un sol dur et tenez-vous dessus en répartissant votre poids uniformément.',
      step2Metric: 'Marquez le talon et l’extrémité de l’orteil le plus long, puis mesurez la distance en centimètres.',
      step2Imperial: 'Marquez le talon et l’extrémité de l’orteil le plus long, puis mesurez la distance en pouces (ou en centimètres).',
      step3: 'Mesurez les deux pieds et retenez la mesure du plus long. Entre deux tailles, choisissez la taille supérieure.',
      fitTitle: 'Note sur la coupe et la conversion',
      shoeNote: 'Les conversions internationales sont données à titre indicatif. La pointure UE d’origine du fournisseur reste liée à votre sélection afin d’ajouter la bonne variante au panier. La coupe peut varier légèrement selon le modèle et le fournisseur.',
      apparelNote: 'La coupe peut varier selon le modèle et le fournisseur. Consultez les indications du produit lorsqu’elles sont disponibles et prenez vos mesures avant de commander.',
      bust: 'Poitrine — mesurez autour de la partie la plus forte de la poitrine.',
      waist: 'Taille — mesurez autour de votre taille naturelle.',
      hips: 'Hanches — mesurez autour de la partie la plus forte des hanches.',
      localHint: 'Les boutons affichent le système de tailles utilisé pour votre marché actuel.',
      close: 'Fermer'
    },
    de: {
      guide: 'Größenhilfe',
      shoeHeading: 'Schuhgröße',
      available: 'Verfügbare Größen',
      marketFor: 'Größen für',
      yourSize: 'Ihre Größe',
      supplierSize: 'EU / Lieferant',
      how: 'So messen Sie',
      step1: 'Legen Sie ein Blatt Papier auf einen harten Boden und stellen Sie sich mit gleichmäßig verteiltem Gewicht darauf.',
      step2Metric: 'Markieren Sie Ferse und längsten Zeh und messen Sie den Abstand in Zentimetern.',
      step2Imperial: 'Markieren Sie Ferse und längsten Zeh und messen Sie den Abstand in Zoll (oder Zentimetern).',
      step3: 'Messen Sie beide Füße und verwenden Sie die längere Messung. Liegen Sie zwischen zwei Größen, wählen Sie die größere.',
      fitTitle: 'Hinweis zu Passform und Umrechnung',
      shoeNote: 'Internationale Größenumrechnungen dienen als Orientierung. Die ursprüngliche EU-Lieferantengröße bleibt intern mit Ihrer Auswahl verknüpft, damit die richtige Variante in den Warenkorb gelegt wird. Die Passform kann je nach Modell und Lieferant leicht variieren.',
      apparelNote: 'Die Passform kann je nach Modell und Lieferant variieren. Beachten Sie vorhandene Produkthinweise und messen Sie Ihren Körper vor der Bestellung.',
      bust: 'Brust — messen Sie an der stärksten Stelle rund um die Brust.',
      waist: 'Taille — messen Sie rund um Ihre natürliche Taille.',
      hips: 'Hüfte — messen Sie an der stärksten Stelle rund um die Hüfte.',
      localHint: 'Die Schaltflächen zeigen das Größensystem Ihres aktuellen Marktes.',
      close: 'Schließen'
    },
    it: {
      guide: 'Guida taglie',
      shoeHeading: 'Numero scarpa',
      available: 'Taglie disponibili',
      marketFor: 'Taglie per',
      yourSize: 'La tua taglia',
      supplierSize: 'UE / fornitore',
      how: 'Come misurare',
      step1: 'Appoggia un foglio di carta su un pavimento rigido e mettiti in piedi distribuendo il peso in modo uniforme.',
      step2Metric: 'Segna il tallone e la punta del dito più lungo, quindi misura la distanza in centimetri.',
      step2Imperial: 'Segna il tallone e la punta del dito più lungo, quindi misura la distanza in pollici (o centimetri).',
      step3: 'Misura entrambi i piedi e usa la misura più lunga. Se sei tra due taglie, scegli quella superiore.',
      fitTitle: 'Nota su vestibilità e conversione',
      shoeNote: 'Le conversioni internazionali sono indicative. Manteniamo internamente la taglia UE originale del fornitore collegata alla tua selezione, così nel carrello viene aggiunta la variante corretta. La vestibilità può variare leggermente in base al modello e al fornitore.',
      apparelNote: 'La vestibilità può variare in base al modello e al fornitore. Consulta le indicazioni del prodotto quando disponibili e prendi le misure prima dell’acquisto.',
      bust: 'Torace — misura intorno alla parte più ampia del busto.',
      waist: 'Vita — misura intorno al punto naturale della vita.',
      hips: 'Fianchi — misura intorno alla parte più ampia dei fianchi.',
      localHint: 'I pulsanti mostrano il sistema di taglie utilizzato nel mercato selezionato.',
      close: 'Chiudi'
    }
  };

  // KIKI_PRODUCT_SIZE_GUIDES_V1
  // Canonical customer-visible product-specific sizing registry.
  // Add verified supplier tables here, keyed by immutable Shopify product ID.
  const PRODUCT_SIZE_COPY = {
    en: {
      chart: 'Product measurements',
      heightWeightChart: 'Height & weight recommendation',
      supplier: 'Supplier measurements',
      size: 'Size', shoulder: 'Shoulder', bust: 'Bust', sleeve: 'Sleeve', length: 'Length', waist: 'Waist', hips: 'Hips',
      height: 'Height', material: 'Material',
      rus: 'RUS', us: 'US', uk: 'UK', au: 'AU', eu: 'EU',
      shoulderMeasure: 'Shoulder — measure straight across the back from shoulder point to shoulder point.',
      sleeveMeasure: 'Sleeve — measure from the shoulder point to the cuff.',
      lengthMeasure: 'Length — measure from the highest shoulder point down to the hem.',
      chooseByChart: 'Choose your size from the measurements in the chart rather than from your usual size alone.',
      manual1to3: 'Manual measurement may vary by 1–3 cm.',
      manualPlusMinus2: 'Manual measurement may vary by ±2 cm.',
      manualPlusMinus3: 'Manual measurement may vary by ±3 cm.',
      manual2to3: 'Manual measurement may vary by 2–3 cm.',
      manualPlusMinus1_5: 'Manual measurement may vary by ±1.5 cm.',
      coldHandWash: 'Cold hand wash is recommended to help preserve shape.',
      noBleach: 'Do not use bleach.',
      referenceOnly: 'Use the chart as a reference and compare it with your own measurements before ordering.',
      heightWeightReference: 'Height and weight recommendations are reference only; your actual body measurements should take priority.',
      matrixUnavailable: 'Blank cells mean the supplier recommendation falls outside the sizes currently offered in this KIKI listing. Do not size up or down automatically.',
      missingSMeasurements: 'Size S is sold on KIKI, but this supplier source does not provide verified measurements for S. Do not infer them from M.',
      elodieInconsistent: 'The supplier waist and hip columns are internally inconsistent, so they are intentionally not shown until verified.',
      moderateElasticity: 'The supplier describes the fabric as moderately elastic.',
      moderateFit: 'The supplier describes the fit as moderate.',
      moderateThickness: 'The supplier describes the fabric thickness as moderate.',
      reference: 'Reference', topMeasurements: 'Top measurements', bottomMeasurements: 'Bottom measurements',
      topLength: 'Top length', bottomLength: 'Bottom length', pantsLength: 'Trousers length', frontLength: 'Front length', sideLength: 'Side length',
      inseam: 'Inseam', outseam: 'Outer leg length', weightRange: 'Weight reference', additionalLength: 'Additional length',
      fitGuidance: 'Fit guidance',
      manual1to2: 'Manual measurement may vary by 1–2 cm.',
      manual2to4: 'Manual measurement may vary by 2–4 cm.',
      manual3to4: 'Manual measurement may vary by 3–4 cm.',
      manualUpTo3: 'Manual measurement may vary by up to 3 cm.',
      supplierGeneralNotPerSize: 'These are general supplier garment measurements and are not mapped to individual sizes.',
      elasticRange: 'Ranges marked by the supplier indicate the elastic measurement range of the garment.',
      highElasticity: 'This knit has high elasticity; use the measurement range as the fit reference.',
      supplierUnitUnspecified: 'The supplier chart does not state a measurement unit, so the values are shown exactly as supplied without assuming cm or inches.',
      missingXSMeasurements: 'Size XS is sold on KIKI, but this supplier source does not provide verified measurements for XS.',
      missingXXXLMeasurements: 'Size XXXL is sold on KIKI, but this supplier source does not provide verified measurements for XXXL.',
      invalidShoulderOmitted: 'The supplier shoulder field contains no valid measurements, so it is intentionally omitted.',
      supplierTablesConflict: 'The supplier provided conflicting lower-body measurements across two charts. Only values that agree between the sources are shown.',
      seraphineFitFeedback: 'Customer feedback indicates a shorter, cropped fit. The length tends to suit heights around 160 cm best; if you are taller, expect the trousers to finish higher on the ankle or lower calf depending on your proportions.',
      softFeel: 'The supplier describes the fabric feel as soft.',
      lightElasticity: 'The supplier indicates slight or micro elasticity.',
      comfortFit: 'The supplier describes the fit as comfortable.',
      noElasticity: 'The supplier describes the fabric as non-stretch.',
      looseFit: 'The supplier describes the fit as loose.',
      boundarySizeUp: 'For borderline height/weight recommendations, the supplier suggests choosing the larger size.',
      supplierXLShownAs1XL: 'The supplier labels the largest row XL; KIKI shows that corresponding selectable size as 1XL.',
      ambiguousSupplierLength: 'The supplier provides an additional field labelled only “Length”; it is shown without reinterpreting what garment part it refers to.',
      ginevraNote: 'Use the S/M/L chart as the primary reference. The additional supplier measurements are a separate general garment reference. Manual measurement may vary by 1–3 cm. This item has some elasticity.',
      victoireNote: 'Choose your size from the measurements in the chart rather than from your usual size alone. Manual measurement may vary by 2–3 cm. Cold hand wash is recommended to help preserve shape. The supplier EU conversion values are internally inconsistent, so that conversion column is intentionally not shown; use bust, waist and garment length as the primary reference.'
    },
    pt: {
      chart: 'Medidas do produto',
      heightWeightChart: 'Recomendação por altura e peso',
      supplier: 'Medidas do fornecedor',
      size: 'Tamanho', shoulder: 'Ombros', bust: 'Peito', sleeve: 'Manga', length: 'Comprimento', waist: 'Cintura', hips: 'Anca',
      height: 'Altura', material: 'Material',
      rus: 'RUS', us: 'EUA', uk: 'Reino Unido', au: 'AU', eu: 'UE',
      shoulderMeasure: 'Ombros — mede em linha reta nas costas, de um ponto do ombro ao outro.',
      sleeveMeasure: 'Manga — mede do ponto do ombro até ao punho.',
      lengthMeasure: 'Comprimento — mede do ponto mais alto do ombro até à bainha.',
      chooseByChart: 'Escolhe o tamanho pelas medidas da tabela e não apenas pelo tamanho que costumas usar.',
      manual1to3: 'A medição manual pode variar 1–3 cm.',
      manualPlusMinus2: 'A medição manual pode variar ±2 cm.',
      manualPlusMinus3: 'A medição manual pode variar ±3 cm.',
      manual2to3: 'A medição manual pode variar 2–3 cm.',
      manualPlusMinus1_5: 'A medição manual pode variar ±1,5 cm.',
      coldHandWash: 'Recomenda-se lavagem à mão com água fria para ajudar a preservar a forma.',
      noBleach: 'Não usar lixívia.',
      referenceOnly: 'Usa a tabela como referência e compara-a com as tuas próprias medidas antes de encomendar.',
      heightWeightReference: 'As recomendações de altura e peso são apenas uma referência; as tuas medidas corporais reais devem ter prioridade.',
      matrixUnavailable: 'As células vazias significam que a recomendação do fornecedor fica fora dos tamanhos atualmente disponíveis nesta ficha KIKI. Não subas nem desças de tamanho automaticamente.',
      missingSMeasurements: 'O tamanho S é vendido na KIKI, mas esta fonte do fornecedor não apresenta medidas verificadas para S. Não as infiras a partir do M.',
      elodieInconsistent: 'As colunas de cintura e anca do fornecedor são internamente inconsistentes, por isso não são apresentadas até serem verificadas.',
      moderateElasticity: 'O fornecedor descreve o tecido como moderadamente elástico.',
      moderateFit: 'O fornecedor descreve o ajuste como moderado.',
      moderateThickness: 'O fornecedor descreve a espessura do tecido como moderada.',
      reference: 'Referência', topMeasurements: 'Medidas da parte superior', bottomMeasurements: 'Medidas da parte inferior',
      topLength: 'Comprimento do top', bottomLength: 'Comprimento da parte inferior', pantsLength: 'Comprimento das calças', frontLength: 'Comprimento frontal', sideLength: 'Comprimento lateral',
      inseam: 'Entreperna', outseam: 'Comprimento exterior da perna', weightRange: 'Peso de referência', additionalLength: 'Comprimento adicional',
      fitGuidance: 'Orientação de ajuste',
      manual1to2: 'A medição manual pode variar 1–2 cm.',
      manual2to4: 'A medição manual pode variar 2–4 cm.',
      manual3to4: 'A medição manual pode variar 3–4 cm.',
      manualUpTo3: 'A medição manual pode variar até 3 cm.',
      supplierGeneralNotPerSize: 'Estas são medidas gerais da peça fornecidas pelo fornecedor e não estão associadas a tamanhos individuais.',
      elasticRange: 'Os intervalos indicados pelo fornecedor representam a faixa elástica da peça.',
      highElasticity: 'Esta malha tem alta elasticidade; usa o intervalo de medidas como referência de ajuste.',
      supplierUnitUnspecified: 'A tabela do fornecedor não indica a unidade de medida, por isso os valores são apresentados exatamente como fornecidos, sem assumir cm ou polegadas.',
      missingXSMeasurements: 'O tamanho XS é vendido na KIKI, mas esta fonte do fornecedor não apresenta medidas verificadas para XS.',
      missingXXXLMeasurements: 'O tamanho XXXL é vendido na KIKI, mas esta fonte do fornecedor não apresenta medidas verificadas para XXXL.',
      invalidShoulderOmitted: 'O campo de ombros do fornecedor não contém medidas válidas e, por isso, foi omitido.',
      supplierTablesConflict: 'O fornecedor apresentou medidas contraditórias para a parte inferior em duas tabelas. Só são mostrados os valores que coincidem entre as fontes.',
      seraphineFitFeedback: 'O feedback de clientes indica um corte mais curto. O comprimento tende a favorecer alturas por volta de 160 cm; se fores mais alta, é provável que as calças terminem mais acima no tornozelo ou na zona inferior da barriga da perna, conforme as proporções.',
      softFeel: 'O fornecedor descreve o toque do tecido como macio.',
      lightElasticity: 'O fornecedor indica elasticidade ligeira ou microelasticidade.',
      comfortFit: 'O fornecedor descreve o ajuste como confortável.',
      noElasticity: 'O fornecedor descreve o tecido como sem elasticidade.',
      looseFit: 'O fornecedor descreve o corte como solto.',
      boundarySizeUp: 'Nos limites entre recomendações de altura/peso, o fornecedor sugere escolher o tamanho superior.',
      supplierXLShownAs1XL: 'O fornecedor identifica a maior linha como XL; na KIKI, o tamanho selecionável correspondente aparece como 1XL.',
      ambiguousSupplierLength: 'O fornecedor inclui um campo adicional identificado apenas como “Comprimento”; é apresentado sem reinterpretar a que parte da peça se refere.',
      ginevraNote: 'Usa a tabela S/M/L como referência principal. As medidas adicionais do fornecedor são uma referência geral separada da peça. A medição manual pode variar 1–3 cm. Este artigo tem alguma elasticidade.',
      victoireNote: 'Escolhe o tamanho pelas medidas da tabela e não apenas pelo tamanho que costumas usar. A medição manual pode variar 2–3 cm. Recomenda-se lavagem à mão com água fria para ajudar a preservar a forma. Os valores de conversão UE fornecidos são internamente inconsistentes, por isso essa coluna não é apresentada; usa peito, cintura e comprimento da peça como referência principal.'
    },
    es: {
      chart: 'Medidas del producto',
      heightWeightChart: 'Recomendación por altura y peso',
      supplier: 'Medidas del proveedor',
      size: 'Talla', shoulder: 'Hombros', bust: 'Pecho', sleeve: 'Manga', length: 'Largo', waist: 'Cintura', hips: 'Cadera',
      height: 'Altura', material: 'Material',
      rus: 'RUS', us: 'EE. UU.', uk: 'Reino Unido', au: 'AU', eu: 'UE',
      shoulderMeasure: 'Hombros — mide en línea recta por la espalda, de un punto del hombro al otro.',
      sleeveMeasure: 'Manga — mide desde el punto del hombro hasta el puño.',
      lengthMeasure: 'Largo — mide desde el punto más alto del hombro hasta el bajo.',
      chooseByChart: 'Elige la talla según las medidas de la tabla y no solo según tu talla habitual.',
      manual1to3: 'La medición manual puede variar 1–3 cm.',
      manualPlusMinus2: 'La medición manual puede variar ±2 cm.',
      manualPlusMinus3: 'La medición manual puede variar ±3 cm.',
      manual2to3: 'La medición manual puede variar 2–3 cm.',
      manualPlusMinus1_5: 'La medición manual puede variar ±1,5 cm.',
      coldHandWash: 'Se recomienda lavar a mano con agua fría para ayudar a conservar la forma.',
      noBleach: 'No usar lejía.',
      referenceOnly: 'Usa la tabla como referencia y compárala con tus propias medidas antes de comprar.',
      heightWeightReference: 'Las recomendaciones de altura y peso son solo orientativas; tus medidas corporales reales deben tener prioridad.',
      matrixUnavailable: 'Las celdas vacías indican que la recomendación del proveedor queda fuera de las tallas disponibles actualmente en esta ficha KIKI. No subas ni bajes de talla automáticamente.',
      missingSMeasurements: 'La talla S se vende en KIKI, pero esta fuente del proveedor no ofrece medidas verificadas para S. No las deduzcas a partir de M.',
      elodieInconsistent: 'Las columnas de cintura y cadera del proveedor son internamente inconsistentes, por lo que no se muestran hasta verificarlas.',
      moderateElasticity: 'El proveedor describe el tejido como moderadamente elástico.',
      moderateFit: 'El proveedor describe el ajuste como moderado.',
      moderateThickness: 'El proveedor describe el grosor del tejido como moderado.',
      reference: 'Referencia', topMeasurements: 'Medidas de la parte superior', bottomMeasurements: 'Medidas de la parte inferior',
      topLength: 'Largo del top', bottomLength: 'Largo de la parte inferior', pantsLength: 'Largo del pantalón', frontLength: 'Largo delantero', sideLength: 'Largo lateral',
      inseam: 'Entrepierna', outseam: 'Largo exterior de la pierna', weightRange: 'Peso de referencia', additionalLength: 'Largo adicional',
      fitGuidance: 'Orientación de ajuste',
      manual1to2: 'La medición manual puede variar 1–2 cm.',
      manual2to4: 'La medición manual puede variar 2–4 cm.',
      manual3to4: 'La medición manual puede variar 3–4 cm.',
      manualUpTo3: 'La medición manual puede variar hasta 3 cm.',
      supplierGeneralNotPerSize: 'Estas son medidas generales de la prenda facilitadas por el proveedor y no están asociadas a tallas individuales.',
      elasticRange: 'Los intervalos indicados por el proveedor representan el rango elástico de la prenda.',
      highElasticity: 'Este punto tiene alta elasticidad; usa el intervalo de medidas como referencia de ajuste.',
      supplierUnitUnspecified: 'La tabla del proveedor no indica la unidad de medida, por lo que los valores se muestran exactamente como fueron facilitados, sin asumir cm o pulgadas.',
      missingXSMeasurements: 'La talla XS se vende en KIKI, pero esta fuente del proveedor no ofrece medidas verificadas para XS.',
      missingXXXLMeasurements: 'La talla XXXL se vende en KIKI, pero esta fuente del proveedor no ofrece medidas verificadas para XXXL.',
      invalidShoulderOmitted: 'El campo de hombros del proveedor no contiene medidas válidas, por lo que se ha omitido.',
      supplierTablesConflict: 'El proveedor facilitó medidas contradictorias de la parte inferior en dos tablas. Solo se muestran los valores que coinciden entre las fuentes.',
      seraphineFitFeedback: 'Los comentarios de clientes indican un corte más corto. El largo suele favorecer alturas cercanas a 160 cm; si eres más alta, es probable que el pantalón termine más arriba del tobillo o en la parte baja de la pantorrilla según tus proporciones.',
      softFeel: 'El proveedor describe el tacto del tejido como suave.',
      lightElasticity: 'El proveedor indica una elasticidad ligera o microelasticidad.',
      comfortFit: 'El proveedor describe el ajuste como cómodo.',
      noElasticity: 'El proveedor describe el tejido como no elástico.',
      looseFit: 'El proveedor describe el corte como holgado.',
      boundarySizeUp: 'En los límites entre recomendaciones de altura/peso, el proveedor sugiere elegir la talla superior.',
      supplierXLShownAs1XL: 'El proveedor etiqueta la fila mayor como XL; en KIKI, la talla seleccionable correspondiente aparece como 1XL.',
      ambiguousSupplierLength: 'El proveedor incluye un campo adicional llamado solo “Largo”; se muestra sin reinterpretar a qué parte de la prenda corresponde.',
      ginevraNote: 'Usa la tabla S/M/L como referencia principal. Las medidas adicionales del proveedor son una referencia general separada de la prenda. La medición manual puede variar 1–3 cm. Este artículo tiene cierta elasticidad.',
      victoireNote: 'Elige la talla según las medidas de la tabla y no solo según tu talla habitual. La medición manual puede variar 2–3 cm. Se recomienda lavar a mano con agua fría para ayudar a conservar la forma. Los valores de conversión UE facilitados por el proveedor son internamente inconsistentes, por lo que esa columna no se muestra; usa pecho, cintura y largo de la prenda como referencia principal.'
    },
    fr: {
      chart: 'Mesures du produit',
      heightWeightChart: 'Recommandation selon la taille et le poids',
      supplier: 'Mesures du fournisseur',
      size: 'Taille', shoulder: 'Épaules', bust: 'Poitrine', sleeve: 'Manche', length: 'Longueur', waist: 'Taille', hips: 'Hanches',
      height: 'Stature', material: 'Matière',
      rus: 'RUS', us: 'US', uk: 'Royaume-Uni', au: 'AU', eu: 'UE',
      shoulderMeasure: 'Épaules — mesurez droit dans le dos, d’un point d’épaule à l’autre.',
      sleeveMeasure: 'Manche — mesurez du point d’épaule jusqu’au poignet.',
      lengthMeasure: 'Longueur — mesurez du point le plus haut de l’épaule jusqu’à l’ourlet.',
      chooseByChart: 'Choisissez la taille d’après les mesures du tableau plutôt qu’uniquement selon votre taille habituelle.',
      manual1to3: 'Une variation de 1 à 3 cm est possible en raison de la mesure manuelle.',
      manualPlusMinus2: 'Une variation de ±2 cm est possible en raison de la mesure manuelle.',
      manualPlusMinus3: 'Une variation de ±3 cm est possible en raison de la mesure manuelle.',
      manual2to3: 'Une variation de 2 à 3 cm est possible en raison de la mesure manuelle.',
      manualPlusMinus1_5: 'Une variation de ±1,5 cm est possible en raison de la mesure manuelle.',
      coldHandWash: 'Un lavage à la main à l’eau froide est recommandé pour aider à préserver la forme.',
      noBleach: 'Ne pas utiliser d’eau de Javel.',
      referenceOnly: 'Utilisez le tableau comme référence et comparez-le à vos propres mesures avant de commander.',
      heightWeightReference: 'Les recommandations de stature et de poids sont indicatives; vos mensurations réelles doivent rester prioritaires.',
      matrixUnavailable: 'Les cellules vides signifient que la recommandation du fournisseur correspond à une taille qui n’est pas proposée actuellement sur cette fiche KIKI. Ne choisissez pas automatiquement une taille au-dessus ou en dessous.',
      missingSMeasurements: 'La taille S est vendue sur KIKI, mais cette source fournisseur ne fournit aucune mesure vérifiée pour S. Ne les déduisez pas à partir du M.',
      elodieInconsistent: 'Les colonnes taille et hanches du fournisseur sont incohérentes entre elles; elles ne sont donc pas affichées tant qu’elles ne sont pas vérifiées.',
      moderateElasticity: 'Le fournisseur décrit le tissu comme modérément extensible.',
      moderateFit: 'Le fournisseur décrit la coupe comme modérée.',
      moderateThickness: 'Le fournisseur décrit l’épaisseur du tissu comme modérée.',
      reference: 'Référence', topMeasurements: 'Mesures du haut', bottomMeasurements: 'Mesures du bas',
      topLength: 'Longueur du haut', bottomLength: 'Longueur du bas', pantsLength: 'Longueur du pantalon', frontLength: 'Longueur devant', sideLength: 'Longueur côté',
      inseam: 'Entrejambe', outseam: 'Longueur extérieure de jambe', weightRange: 'Poids indicatif', additionalLength: 'Longueur supplémentaire',
      fitGuidance: 'Conseil de coupe',
      manual1to2: 'Une variation de 1 à 2 cm est possible en raison de la mesure manuelle.',
      manual2to4: 'Une variation de 2 à 4 cm est possible en raison de la mesure manuelle.',
      manual3to4: 'Une variation de 3 à 4 cm est possible en raison de la mesure manuelle.',
      manualUpTo3: 'Une variation pouvant aller jusqu’à 3 cm est possible en raison de la mesure manuelle.',
      supplierGeneralNotPerSize: 'Il s’agit de mesures générales du vêtement fournies par le fournisseur et non associées à des tailles individuelles.',
      elasticRange: 'Les intervalles indiqués par le fournisseur correspondent à la plage d’élasticité du vêtement.',
      highElasticity: 'Cette maille est très extensible ; utilisez la plage de mesures comme référence de coupe.',
      supplierUnitUnspecified: 'Le tableau du fournisseur ne précise pas l’unité de mesure; les valeurs sont donc affichées telles quelles, sans supposer des cm ou des pouces.',
      missingXSMeasurements: 'La taille XS est vendue sur KIKI, mais cette source fournisseur ne fournit pas de mesures vérifiées pour XS.',
      missingXXXLMeasurements: 'La taille XXXL est vendue sur KIKI, mais cette source fournisseur ne fournit pas de mesures vérifiées pour XXXL.',
      invalidShoulderOmitted: 'Le champ épaules du fournisseur ne contient aucune mesure valide et a donc été omis.',
      supplierTablesConflict: 'Le fournisseur a fourni des mesures contradictoires pour le bas dans deux tableaux. Seules les valeurs concordantes entre les sources sont affichées.',
      seraphineFitFeedback: 'Les retours clients indiquent une coupe plus courte. La longueur convient généralement mieux autour de 160 cm; si vous êtes plus grande, le pantalon peut finir plus haut sur la cheville ou au bas du mollet selon vos proportions.',
      softFeel: 'Le fournisseur décrit le toucher du tissu comme doux.',
      lightElasticity: 'Le fournisseur indique une légère ou micro-élasticité.',
      comfortFit: 'Le fournisseur décrit la coupe comme confortable.',
      noElasticity: 'Le fournisseur décrit le tissu comme non extensible.',
      looseFit: 'Le fournisseur décrit la coupe comme ample.',
      boundarySizeUp: 'À la limite entre deux recommandations taille/poids, le fournisseur conseille de choisir la taille supérieure.',
      supplierXLShownAs1XL: 'Le fournisseur appelle la plus grande ligne XL; sur KIKI, la taille sélectionnable correspondante apparaît comme 1XL.',
      ambiguousSupplierLength: 'Le fournisseur ajoute un champ intitulé uniquement « Longueur »; il est affiché sans réinterpréter la partie du vêtement concernée.',
      ginevraNote: 'Utilisez le tableau S/M/L comme référence principale. Les mesures supplémentaires du fournisseur sont une référence générale distincte du vêtement. Une variation de 1 à 3 cm est possible en raison de la mesure manuelle. Cet article présente une certaine élasticité.',
      victoireNote: 'Choisissez la taille d’après les mesures du tableau plutôt qu’uniquement selon votre taille habituelle. Une variation de 2 à 3 cm est possible en raison de la mesure manuelle. Un lavage à la main à l’eau froide est recommandé pour aider à préserver la forme. Les valeurs de conversion UE fournies sont incohérentes entre elles; cette colonne n’est donc pas affichée. Utilisez surtout la poitrine, la taille et la longueur du vêtement.'
    },
    de: {
      chart: 'Produktmaße',
      heightWeightChart: 'Empfehlung nach Körpergröße und Gewicht',
      supplier: 'Lieferantenmaße',
      size: 'Größe', shoulder: 'Schulter', bust: 'Brust', sleeve: 'Ärmel', length: 'Länge', waist: 'Taille', hips: 'Hüfte',
      height: 'Körpergröße', material: 'Material',
      rus: 'RUS', us: 'US', uk: 'UK', au: 'AU', eu: 'EU',
      shoulderMeasure: 'Schulter — gerade über den Rücken von Schulterpunkt zu Schulterpunkt messen.',
      sleeveMeasure: 'Ärmel — vom Schulterpunkt bis zum Bündchen messen.',
      lengthMeasure: 'Länge — vom höchsten Schulterpunkt bis zum Saum messen.',
      chooseByChart: 'Wähle die Größe anhand der Maße in der Tabelle und nicht nur nach deiner gewohnten Konfektionsgröße.',
      manual1to3: 'Durch manuelles Messen sind Abweichungen von 1–3 cm möglich.',
      manualPlusMinus2: 'Durch manuelles Messen sind Abweichungen von ±2 cm möglich.',
      manualPlusMinus3: 'Durch manuelles Messen sind Abweichungen von ±3 cm möglich.',
      manual2to3: 'Durch manuelles Messen sind Abweichungen von 2–3 cm möglich.',
      manualPlusMinus1_5: 'Durch manuelles Messen sind Abweichungen von ±1,5 cm möglich.',
      coldHandWash: 'Kalte Handwäsche wird empfohlen, um die Form besser zu erhalten.',
      noBleach: 'Keine Bleiche verwenden.',
      referenceOnly: 'Nutze die Tabelle als Orientierung und vergleiche sie vor der Bestellung mit deinen eigenen Maßen.',
      heightWeightReference: 'Empfehlungen nach Körpergröße und Gewicht dienen nur als Orientierung; deine tatsächlichen Körpermaße haben Vorrang.',
      matrixUnavailable: 'Leere Felder bedeuten, dass die Lieferantenempfehlung einer Größe entspricht, die in diesem KIKI-Angebot derzeit nicht erhältlich ist. Wähle nicht automatisch eine größere oder kleinere Größe.',
      missingSMeasurements: 'Größe S wird bei KIKI verkauft, aber diese Lieferantenquelle enthält keine verifizierten Maße für S. Leite sie nicht von M ab.',
      elodieInconsistent: 'Die vom Lieferanten angegebenen Spalten für Taille und Hüfte sind untereinander widersprüchlich und werden deshalb bis zur Verifizierung nicht angezeigt.',
      moderateElasticity: 'Der Lieferant beschreibt den Stoff als mäßig elastisch.',
      moderateFit: 'Der Lieferant beschreibt die Passform als moderat.',
      moderateThickness: 'Der Lieferant beschreibt die Stoffdicke als moderat.',
      reference: 'Referenz', topMeasurements: 'Maße Oberteil', bottomMeasurements: 'Maße Unterteil',
      topLength: 'Oberteillänge', bottomLength: 'Länge Unterteil', pantsLength: 'Hosenlänge', frontLength: 'Vordere Länge', sideLength: 'Seitenlänge',
      inseam: 'Innenbeinlänge', outseam: 'Äußere Beinlänge', weightRange: 'Gewichtsempfehlung', additionalLength: 'Zusätzliche Länge',
      fitGuidance: 'Passformhinweis',
      manual1to2: 'Durch manuelles Messen sind Abweichungen von 1–2 cm möglich.',
      manual2to4: 'Durch manuelles Messen sind Abweichungen von 2–4 cm möglich.',
      manual3to4: 'Durch manuelles Messen sind Abweichungen von 3–4 cm möglich.',
      manualUpTo3: 'Durch manuelles Messen sind Abweichungen von bis zu 3 cm möglich.',
      supplierGeneralNotPerSize: 'Dies sind allgemeine Kleidungsmaße des Lieferanten und keine einzelnen Größen zugeordneten Maße.',
      elasticRange: 'Die vom Lieferanten angegebenen Bereiche entsprechen dem elastischen Messbereich des Kleidungsstücks.',
      highElasticity: 'Dieser Strick ist stark elastisch; verwenden Sie den Messbereich als Passformreferenz.',
      supplierUnitUnspecified: 'In der Lieferantentabelle ist keine Maßeinheit angegeben; die Werte werden daher genau wie geliefert angezeigt, ohne cm oder Zoll anzunehmen.',
      missingXSMeasurements: 'Größe XS wird bei KIKI verkauft, aber diese Lieferantenquelle enthält keine verifizierten Maße für XS.',
      missingXXXLMeasurements: 'Größe XXXL wird bei KIKI verkauft, aber diese Lieferantenquelle enthält keine verifizierten Maße für XXXL.',
      invalidShoulderOmitted: 'Das Schulterfeld des Lieferanten enthält keine gültigen Maße und wurde deshalb weggelassen.',
      supplierTablesConflict: 'Der Lieferant hat in zwei Tabellen widersprüchliche Maße für das Unterteil angegeben. Angezeigt werden nur Werte, die zwischen den Quellen übereinstimmen.',
      seraphineFitFeedback: 'Kundenfeedback deutet auf eine kürzere, verkürzte Passform hin. Die Länge passt meist besser bei etwa 160 cm Körpergröße; bei größeren Personen kann die Hose je nach Proportionen höher am Knöchel oder am unteren Unterschenkel enden.',
      softFeel: 'Der Lieferant beschreibt den Stoff als weich.',
      lightElasticity: 'Der Lieferant gibt eine leichte bzw. Mikro-Elastizität an.',
      comfortFit: 'Der Lieferant beschreibt die Passform als bequem.',
      noElasticity: 'Der Lieferant beschreibt den Stoff als nicht elastisch.',
      looseFit: 'Der Lieferant beschreibt die Passform als locker.',
      boundarySizeUp: 'An Grenzwerten der Größen-/Gewichtsempfehlung rät der Lieferant zur größeren Größe.',
      supplierXLShownAs1XL: 'Der Lieferant bezeichnet die größte Zeile als XL; bei KIKI erscheint die entsprechende auswählbare Größe als 1XL.',
      ambiguousSupplierLength: 'Der Lieferant führt ein zusätzliches Feld nur mit der Bezeichnung „Länge“ auf; es wird angezeigt, ohne den betreffenden Kleidungsbereich neu zu interpretieren.',
      ginevraNote: 'Die S/M/L-Tabelle ist die wichtigste Referenz. Die zusätzlichen Lieferantenmaße sind eine separate allgemeine Referenz für das Kleidungsstück. Durch manuelles Messen sind Abweichungen von 1–3 cm möglich. Dieser Artikel hat etwas Elastizität.',
      victoireNote: 'Wähle die Größe anhand der Maße in der Tabelle und nicht nur nach deiner gewohnten Konfektionsgröße. Durch manuelles Messen sind Abweichungen von 2–3 cm möglich. Kalte Handwäsche wird empfohlen, um die Form besser zu erhalten. Die vom Lieferanten angegebenen EU-Umrechnungswerte sind untereinander widersprüchlich; deshalb wird diese Spalte nicht angezeigt. Nutze Brust, Taille und Kleidlänge als wichtigste Referenz.'
    }
  };

  const PRODUCT_SIZE_GUIDES = {
    // Previously completed guides
    '11116353749329': {
      key: 'ginevra',
      columns: ['size','shoulder','bust','sleeve','length'],
      rows: [
        ['S','34 cm','88–98 cm','49 cm','101 cm'],
        ['M','35 cm','90–100 cm','50 cm','102 cm'],
        ['L','36 cm','92–102 cm','51 cm','103 cm']
      ],
      general: [
        ['bust','94–104 cm · 37.01–40.94 in'],
        ['length','104 cm · 40.94 in'],
        ['shoulder','37 cm · 14.57 in'],
        ['sleeve','52 cm · 20.47 in']
      ],
      measures: ['bust','shoulder','sleeve','length'],
      noteKey: 'ginevraNote'
    },
    '11108052959569': {
      key: 'victoire',
      wide: true,
      columns: ['size','rus','us','uk','au','bust','length','waist'],
      rows: [
        ['S','44','4–6','8','8','90 cm · 35.10 in','112 cm · 43.68 in','74 cm · 28.86 in'],
        ['M','46','8–10','10','10','94 cm · 36.66 in','113 cm · 44.07 in','78 cm · 30.42 in'],
        ['L','48','12','12','12','100 cm · 39.00 in','114 cm · 44.46 in','84 cm · 32.76 in'],
        ['XL','50','14','14','14','106 cm · 41.34 in','115 cm · 44.85 in','90 cm · 35.10 in'],
        ['XXL','52','16','16','16','112 cm · 43.68 in','116 cm · 45.24 in','96 cm · 37.44 in'],
        ['XXXL','54','18','18','18','118 cm · 46.02 in','117 cm · 45.63 in','102 cm · 39.78 in']
      ],
      measures: ['bust','waist','length'],
      noteKey: 'victoireNote'
    },

    // Batch 1
    '11103735120209': {
      key: 'camille',
      titleKey: 'heightWeightChart',
      wide: true,
      columns: ['height','40–45 kg','45–50 kg','50–55 kg','55–62 kg','62–70 kg'],
      rows: [
        ['150–155 cm','—','S','M','L','—'],
        ['155–160 cm','S','S','M','M','L'],
        ['160–165 cm','S','S','M','M','L'],
        ['165–170 cm','S','M','M','L','L'],
        ['170–175 cm','M','M','L','L','—']
      ],
      measures: ['bust','waist','hips'],
      notes: ['heightWeightReference','matrixUnavailable']
    },
    '11103626527057': {
      key: 'solene',
      columns: ['size','bust','waist','shoulder','length'],
      rows: [
        ['S','76 cm','68 cm','34 cm','129 cm'],
        ['M','80 cm','72 cm','35 cm','130 cm'],
        ['L','84 cm','76 cm','36 cm','131 cm']
      ],
      general: [['material','95% polyester / 5% spandex']],
      measures: ['bust','waist','shoulder','length'],
      notes: ['chooseByChart','manualPlusMinus2','moderateElasticity','moderateFit','moderateThickness']
    },
    '11100444262737': {
      key: 'marielle',
      columns: ['size','bust','sleeve','waist','length'],
      rows: [
        ['XS','86 cm · 33.80 in','25 cm · 9.83 in','60 cm · 23.60 in','134 cm · 52.70 in'],
        ['S','90 cm · 35.37 in','26 cm · 10.22 in','64 cm · 25.15 in','135 cm · 53.06 in'],
        ['M','94 cm · 36.94 in','27 cm · 10.61 in','68 cm · 26.72 in','136 cm · 53.45 in'],
        ['L','98 cm · 38.51 in','28 cm · 11.00 in','72 cm · 28.30 in','137 cm · 53.84 in']
      ],
      measures: ['bust','waist','sleeve','length'],
      notes: ['chooseByChart','manualPlusMinus3','coldHandWash','noBleach']
    },
    '11094862430545': {
      key: 'sienna',
      wide: true,
      columns: ['size','us','uk','eu','bust','shoulder','sleeve','length'],
      rows: [
        ['M','6','10','34','95 cm · 37.40 in','40 cm · 15.75 in','59.6 cm · 23.46 in','93 cm · 36.61 in'],
        ['L','8','12','36','100 cm · 39.37 in','41 cm · 16.14 in','60.2 cm · 23.70 in','94 cm · 37.01 in'],
        ['XL','10','14','38','105 cm · 41.34 in','42 cm · 16.54 in','60.8 cm · 23.94 in','95 cm · 37.40 in'],
        ['XXL','12','16','40','110 cm · 43.31 in','43 cm · 16.93 in','61.4 cm · 24.17 in','96 cm · 37.80 in']
      ],
      measures: ['bust','shoulder','sleeve','length'],
      notes: ['manualPlusMinus1_5','referenceOnly','missingSMeasurements']
    },
    '11089216373073': {
      key: 'delphine',
      columns: ['size','bust','length','sleeve'],
      rows: [
        ['S','103 cm','82 cm','106 cm'],
        ['M','107 cm','83 cm','110 cm'],
        ['L','113 cm','84 cm','116 cm'],
        ['XL','119 cm','85 cm','122 cm'],
        ['XXL','125 cm','86 cm','128 cm']
      ],
      measures: ['bust','sleeve','length'],
      notes: ['chooseByChart','manual2to3','coldHandWash']
    },
    '11075081011537': {
      key: 'juliette',
      columns: ['size','bust','waist','hips','length'],
      rows: [
        ['S','70–80 cm','64–70 cm','88–98 cm','128 cm'],
        ['M','74–84 cm','68–74 cm','92–102 cm','129 cm'],
        ['L','78–88 cm','72–78 cm','96–106 cm','130 cm']
      ],
      measures: ['bust','waist','hips','length'],
      notes: ['chooseByChart','manual1to3']
    },
    '11075027501393': {
      key: 'elodie',
      columns: ['size','bust','length','sleeve','shoulder'],
      rows: [
        ['S','102 cm','128 cm','55 cm','47 cm'],
        ['M','106 cm','129 cm','56 cm','49 cm'],
        ['L','112 cm','130 cm','57 cm','52 cm'],
        ['XL','118 cm','131 cm','58 cm','55 cm'],
        ['XXL','124 cm','132 cm','59 cm','58 cm']
      ],
      measures: ['bust','shoulder','sleeve','length'],
      notes: ['elodieInconsistent']
    },
    '11190574678353': {
      key: 'eliane',
      columns: ['size','bust','length','shoulder','sleeve'],
      rows: [
        ['One Size','68–96 cm · 26.77–37.80 in','54 cm · 21.26 in','26–48 cm · 10.24–18.90 in','54 cm · 21.26 in']
      ],
      measures: ['bust','shoulder','sleeve','length'],
      notes: []
    },
    // Cléophée 11190577234257 intentionally omitted:
    // Shopify currently exposes only "One Size", while the supplied chart is S/M/G/XL.
    // Do not map or publish that chart until the variant structure is reconciled with the supplier.
    '11190586671441': {
      key: 'noelie',
      columns: ['size','us','eu','bust','length'],
      rows: [
        ['S','4–6','34–36','104 cm · 40.9 in','60 cm · 23.6 in'],
        ['M','8–10','38–40','108 cm · 42.5 in','62 cm · 24.4 in'],
        ['L','12–14','42','112 cm · 44.1 in','64 cm · 25.2 in'],
        ['XL','16–18','44','116 cm · 45.7 in','66 cm · 26.0 in']
      ],
      measures: ['bust','length'],
      notes: ['chooseByChart','manual2to3']
    },

    // Full catalog sizing batch — 41 products
    '11167590056273': {
      key: 'celestine',
      titleKey: 'supplier',
      general: [['bust','108 cm · 42.52 in'],['length','71 cm · 27.95 in']],
      measures: ['bust','length'],
      notes: ['supplierGeneralNotPerSize']
    },
    '11167918358865': {
      key: 'sidonie',
      columns: ['size','bust','length'],
      rows: [['S','80 cm','50 cm'],['M','84 cm','51 cm'],['L','88 cm','52 cm']],
      measures: ['bust','length'],
      notes: ['chooseByChart']
    },
    '11095749984593': {
      key: 'celeste',
      columns: ['size','bust','shoulder','sleeve','length'],
      rows: [
        ['S','97 cm · 38.19 in','38.5 cm · 15.16 in','60 cm · 23.62 in','64 cm · 25.20 in'],
        ['M','102 cm · 40.16 in','39.5 cm · 15.55 in','61 cm · 24.02 in','65 cm · 25.59 in'],
        ['L','108 cm · 42.52 in','40.5 cm · 15.94 in','62.2 cm · 24.49 in','66.5 cm · 26.18 in'],
        ['XL','115 cm · 45.28 in','42 cm · 16.54 in','63.4 cm · 24.96 in','68 cm · 26.77 in']
      ],
      measures: ['bust','shoulder','sleeve','length'],
      notes: ['manual1to2']
    },
    '11075056271697': {
      key: 'colette',
      columns: ['size','bust','length','shoulder','sleeve'],
      rows: [['S','104 cm','62 cm','45 cm','58 cm'],['M','108 cm','63 cm','46 cm','59 cm'],['L','112 cm','64 cm','47 cm','60 cm']],
      measures: ['bust','shoulder','sleeve','length'],
      notes: ['chooseByChart','manualPlusMinus3','coldHandWash','noBleach']
    },
    '11199691915601': {
      key: 'adelie',
      columns: ['size','shoulder','bust','length','sleeve'],
      rows: [['One Size','32–42 cm','120 cm','54 cm','57 cm']],
      measures: ['bust','shoulder','sleeve','length'],
      notes: ['manualUpTo3','elasticRange']
    },
    '11199652036945': {
      key: 'celiane',
      columns: ['size','shoulder','bust','length','sleeve'],
      rows: [['One Size','28–40 cm','78–96 cm','54 cm','55 cm']],
      measures: ['bust','shoulder','sleeve','length'],
      notes: ['manualUpTo3','elasticRange']
    },
    '11199646564689': {
      key: 'romane',
      columns: ['size','bust','shoulder','sleeve','length'],
      rows: [
        ['S','78–90 cm','30 cm','55 cm','56 cm'],['M','84–96 cm','31 cm','56 cm','57 cm'],
        ['L','90–102 cm','32 cm','57 cm','58 cm'],['XL','96–106 cm','33 cm','58 cm','59 cm']
      ],
      measures: ['bust','shoulder','sleeve','length'],
      notes: ['manual2to4','chooseByChart']
    },
    '11199640961361': {
      key: 'maeva',
      columns: ['size','shoulder','sleeve','bust','length'],
      rows: [
        ['S','53 cm','50 cm','100 cm','65 cm'],['M','54 cm','51 cm','104 cm','66 cm'],['L','55 cm','52 cm','108 cm','67 cm'],
        ['XL','56 cm','53 cm','112 cm','68 cm'],['XXL','57 cm','54 cm','116 cm','69 cm']
      ],
      measures: ['bust','shoulder','sleeve','length'],
      notes: []
    },
    '11144584134993': {
      key: 'ottavia',
      columns: ['size','length','bust','shoulder','sleeve','weightRange'],
      rows: [
        ['S','50 cm','88 cm','35 cm','52 cm','40–45 kg'],
        ['M','51 cm','92 cm','36 cm','53 cm','45–50 kg'],
        ['L','52 cm','96 cm','37 cm','54 cm','50–55 kg']
      ],
      measures: ['bust','shoulder','sleeve','length'],
      notes: ['manual2to3','missingXSMeasurements','heightWeightReference','chooseByChart']
    },
    '11178375610705': {
      key: 'flavie',
      columns: ['size','waist','hips','length'],
      rows: [
        ['XS','64 cm · 25.20 in','92 cm · 36.22 in','115 cm · 45.28 in'],
        ['S','68 cm · 26.77 in','96 cm · 37.80 in','116 cm · 45.67 in'],
        ['M','72 cm · 28.35 in','100 cm · 39.37 in','117 cm · 46.06 in'],
        ['L','78 cm · 30.71 in','106 cm · 41.73 in','118.5 cm · 46.65 in']
      ],
      measures: ['waist','hips','length'],
      notes: ['manualUpTo3']
    },
    '11176447213905': {
      key: 'lisette',
      columns: ['size','waist','hips','length'],
      rows: [
        ['XS','64 cm · 25.15 in','98 cm · 38.51 in','112 cm · 44.02 in'],
        ['S','68 cm · 26.70 in','102 cm · 40.10 in','113 cm · 44.40 in'],
        ['M','72 cm · 28.30 in','106 cm · 41.66 in','114 cm · 44.80 in'],
        ['L','76 cm · 29.87 in','110 cm · 43.23 in','115 cm · 45.20 in']
      ],
      measures: ['waist','hips','length'],
      notes: ['chooseByChart','manualPlusMinus3','coldHandWash','noBleach']
    },
    '11176440758609': {
      key: 'anaelle',
      columns: ['size','length','inseam','waist','hips'],
      rows: [
        ['S','106 cm · 41.73 in','71 cm · 27.95 in','69 cm · 27.17 in','101 cm · 39.76 in'],
        ['M','107 cm · 42.13 in','71.3 cm · 28.07 in','73 cm · 28.74 in','105 cm · 41.34 in'],
        ['L','108 cm · 42.52 in','71.6 cm · 28.19 in','79 cm · 31.10 in','111 cm · 43.70 in'],
        ['XL','109 cm · 42.91 in','71.9 cm · 28.31 in','85 cm · 33.46 in','117 cm · 46.06 in'],
        ['XXL','110 cm · 43.31 in','72.2 cm · 28.43 in','91 cm · 35.83 in','123 cm · 48.43 in']
      ],
      measures: ['waist','hips','length'],
      notes: ['manual1to2']
    },
    '11095291429201': {
      key: 'elara',
      columns: ['size','waist','hips','length'],
      rows: [['S','68 cm','124 cm','100 cm'],['M','72 cm','128 cm','101 cm'],['L','76 cm','132 cm','102 cm']],
      general: [['material','100% cotton']],
      measures: ['waist','hips','length'],
      notes: ['chooseByChart','manual1to2','moderateThickness','noElasticity','looseFit']
    },
    '11100018377041': {
      key: 'seraphine',
      titleKey: 'fitGuidance',
      general: [['size','One Size']],
      measures: ['waist','hips','length'],
      notes: ['seraphineFitFeedback']
    },
    '11099903754577': {
      key: 'aurelia',
      wide: true,
      columns: ['size','hips','pantsLength','waist'],
      rows: [
        ['S','86.1','109','63'],['M','89.9','110','67.1'],['L','96','111','72.9'],
        ['XL','102.1','112','79'],['XXL','108','113','85.1'],['XXXL','112','114','92']
      ],
      measures: ['waist','hips','length'],
      notes: ['supplierUnitUnspecified']
    },
    '11193124651345': {
      key: 'albane',
      columns: ['size','bust','shoulder','sleeve','length'],
      rows: [['S','116 cm · 45.67 in','63 cm · 24.8 in','48 cm · 18.89 in','76 cm · 29.92 in'],['M','120 cm · 47.24 in','64 cm · 25.19 in','49 cm · 19.29 in','77 cm · 30.31 in'],['L','126 cm · 49.61 in','65 cm · 25.59 in','50 cm · 19.68 in','78 cm · 30.7 in']],
      measures: ['bust','shoulder','sleeve','length'],
      notes: ['chooseByChart','manual2to3']
    },
    '11193133072721': {
      key: 'heloise',
      columns: ['size','length','sleeve','shoulder','bust'],
      rows: [['S','62 cm · 24.4 in','47 cm · 18.5 in','59 cm · 23.2 in','114 cm · 44.9 in'],['M','63 cm · 24.8 in','48 cm · 18.9 in','60 cm · 23.6 in','118 cm · 46.5 in'],['L','64 cm · 25.2 in','49 cm · 19.3 in','61 cm · 24.0 in','124 cm · 48.8 in']],
      measures: ['bust','shoulder','sleeve','length'],
      notes: ['chooseByChart','manual1to3']
    },
    '11190583689553': {
      key: 'eulalie',
      titleKey: 'supplier',
      general: [['bust','110 cm · 43.31 in'],['length','57 cm · 22.44 in'],['shoulder','45 cm · 17.72 in'],['sleeve','69 cm · 27.17 in']],
      measures: ['bust','shoulder','sleeve','length'],
      notes: ['supplierGeneralNotPerSize']
    },
    '11190586114385': {
      key: 'melisande',
      columns: ['size','bust','length','shoulder','sleeve'],
      rows: [['S','106 cm · 41.73 in','62 cm · 24.41 in','49 cm · 19.29 in','50 cm · 19.69 in'],['M','110 cm · 43.31 in','63 cm · 24.80 in','50 cm · 19.69 in','51 cm · 20.08 in'],['L','114 cm · 44.88 in','64 cm · 25.20 in','51 cm · 20.08 in','52 cm · 20.47 in']],
      measures: ['bust','shoulder','sleeve','length'],
      notes: ['manual1to3']
    },
    '11190587457873': {
      key: 'florine',
      columns: ['size','shoulder','bust','sleeve','frontLength'],
      rows: [['S','50 cm','114 cm','55 cm','63 cm'],['M','51 cm','118 cm','56 cm','64 cm'],['L','52.5 cm','124 cm','57 cm','65 cm']],
      measures: ['bust','shoulder','sleeve','length'],
      notes: ['manual1to3']
    },
    '11190584967505': {
      key: 'emeline',
      tables: [
        {
          titleKey: 'chart',
          columns: ['size','bust','length','sleeve'],
          rows: [['S','122 cm','69 cm','60 cm'],['M','126 cm','70 cm','61 cm'],['L','130 cm','71 cm','62 cm']]
        },
        {
          titleKey: 'heightWeightChart',
          wide: true,
          columns: ['height','45–51 kg','51–57 kg','57–63 kg','64–72 kg'],
          rows: [['160–165 cm','S','M','M','L'],['165–170 cm','S','M','M','L'],['170–175 cm','M','M','L','L'],['175–180 cm','L','L','L','L']]
        }
      ],
      measures: ['bust','sleeve','length'],
      notes: ['manual2to3','heightWeightReference','boundarySizeUp']
    },
    '11167590744401': {
      key: 'esmee',
      columns: ['size','bust','sleeve','waist','length'],
      rows: [['S','94 cm','60 cm','80 cm','50 cm'],['M','98 cm','61 cm','84 cm','51 cm'],['L','102 cm','62 cm','88 cm','52 cm']],
      measures: ['bust','waist','sleeve','length'],
      notes: []
    },
    '11176451506513': {
      key: 'claudine',
      columns: ['size','bust','shoulder','sleeve','length'],
      rows: [['S','104 cm · 40.94 in','42 cm · 16.53 in','58 cm · 22.83 in','51 cm · 20.07 in'],['M','108 cm · 42.52 in','43 cm · 16.92 in','59 cm · 23.22 in','52 cm · 20.47 in'],['L','114 cm · 44.88 in','44 cm · 17.32 in','60 cm · 23.62 in','53 cm · 20.86 in'],['XL','120 cm · 47.24 in','45 cm · 17.71 in','61 cm · 24.01 in','54 cm · 21.25 in']],
      measures: ['bust','shoulder','sleeve','length'],
      notes: ['chooseByChart','manual2to3']
    },
    '11148431327569': {
      key: 'garance',
      columns: ['size','shoulder','bust','length','sleeve'],
      rows: [['XS','52 cm · 20.47 in','108 cm · 42.52 in','52 cm · 20.47 in','55 cm · 21.65 in'],['S','53 cm · 20.87 in','112 cm · 44.09 in','53 cm · 20.87 in','56 cm · 22.05 in'],['M','54 cm · 21.26 in','116 cm · 45.67 in','54 cm · 21.26 in','57 cm · 22.44 in'],['L','55 cm · 21.65 in','120 cm · 47.24 in','55 cm · 21.65 in','58 cm · 22.83 in']],
      measures: ['bust','shoulder','sleeve','length'],
      notes: ['manualUpTo3']
    },
    '11144196718929': {
      key: 'ariane',
      columns: ['size','bust','shoulder','sleeve','length'],
      rows: [['XS','94 cm · 37.01 in','43 cm · 16.93 in','60 cm · 23.62 in','61 cm · 24.02 in'],['S','98 cm · 38.58 in','44 cm · 17.32 in','61 cm · 24.02 in','62 cm · 24.41 in'],['M','102 cm · 40.16 in','45 cm · 17.72 in','62 cm · 24.41 in','63 cm · 24.80 in'],['L','106 cm · 41.73 in','46 cm · 18.11 in','63 cm · 24.80 in','64 cm · 25.20 in']],
      measures: ['bust','shoulder','sleeve','length'],
      notes: []
    },
    '11137520632145': {
      key: 'fiorella',
      columns: ['size','shoulder','bust','length','sleeve'],
      rows: [['S','56 cm','112 cm','73 cm','48 cm'],['M','57 cm','116 cm','74 cm','48.5 cm'],['L','58 cm','120 cm','75 cm','49 cm']],
      measures: ['bust','shoulder','sleeve','length'],
      notes: []
    },
    '11116802703697': {
      key: 'margaux',
      wide: true,
      columns: ['size','bust','shoulder','sleeve','topLength','waist','hips','additionalLength'],
      rows: [
        ['XS','129 cm · 50.7 in','54 cm · 21.2 in','59 cm · 23.2 in','54 cm · 21.2 in','64 cm · 25.2 in','94 cm · 36.9 in','34 cm · 13.4 in'],
        ['S','133 cm · 52.3 in','55 cm · 21.6 in','60 cm · 23.6 in','55 cm · 21.6 in','68 cm · 26.7 in','98 cm · 38.5 in','35 cm · 13.8 in'],
        ['M','137 cm · 53.8 in','56 cm · 22.0 in','61 cm · 24.0 in','56 cm · 22.0 in','72 cm · 28.3 in','102 cm · 40.1 in','36 cm · 14.1 in'],
        ['L','141 cm · 55.4 in','57 cm · 22.4 in','62 cm · 24.4 in','57 cm · 22.4 in','76 cm · 29.9 in','106 cm · 41.7 in','37 cm · 14.5 in']
      ],
      measures: ['bust','shoulder','sleeve','waist','hips','length'],
      notes: ['manualPlusMinus3','chooseByChart','coldHandWash','noBleach','ambiguousSupplierLength']
    },
    '11095089250641': {
      key: 'amara',
      columns: ['size','bust','length','sleeve'],
      rows: [['XS','114 cm · 44.88 in','53 cm · 20.87 in','56 cm · 22.06 in'],['S','118 cm · 46.46 in','54 cm · 21.26 in','57 cm · 22.46 in'],['M','122 cm · 48.03 in','55 cm · 21.65 in','58 cm · 22.85 in'],['L','128 cm · 50.39 in','56.5 cm · 22.24 in','59.5 cm · 23.44 in']],
      measures: ['bust','sleeve','length'],
      notes: ['manualPlusMinus3','chooseByChart','coldHandWash','noBleach','invalidShoulderOmitted']
    },
    '11089637245265': {
      key: 'eleonore',
      columns: ['size','shoulder','bust','length','sleeve'],
      rows: [['S','39 cm','94 cm','74 cm','60 cm'],['M','40 cm','98 cm','75 cm','61 cm'],['L','41 cm','104 cm','76 cm','62 cm']],
      measures: ['bust','shoulder','sleeve','length'],
      notes: ['manualPlusMinus3','chooseByChart','coldHandWash','noBleach','missingXSMeasurements']
    },
    '11178377216337': {
      key: 'elvire',
      wide: true,
      columns: ['size','bust','length','sleeve','waist','hips','outseam'],
      rows: [
        ['S','94 cm','50 cm','50 cm','66 cm','102 cm','108 cm'],['M','98 cm','51 cm','51 cm','70 cm','106 cm','109 cm'],
        ['L','104 cm','52 cm','52 cm','76 cm','112 cm','110 cm'],['XL','110 cm','53 cm','53 cm','82 cm','118 cm','111 cm'],
        ['XXL','116 cm','54 cm','54 cm','88 cm','124 cm','112 cm']
      ],
      measures: ['bust','waist','hips','sleeve','length'],
      notes: ['missingXXXLMeasurements']
    },
    '11178376692049': {
      key: 'odette',
      tables: [
        {
          titleKey: 'topMeasurements',
          columns: ['size','topLength','bust','sleeve'],
          rows: [
            ['S','73 cm · 28.7 in','100 cm · 39.4 in','60 cm'],['M','74 cm · 29.1 in','105 cm · 41.3 in','61 cm'],
            ['L','75 cm · 29.5 in','110 cm · 43.3 in','62 cm'],['XL','76 cm · 29.9 in','115 cm · 45.3 in','63 cm'],
            ['XXL','77 cm · 30.3 in','120 cm · 47.2 in','64 cm'],['XXXL','78 cm · 30.7 in','125 cm · 49.2 in','65 cm']
          ]
        },
        {
          titleKey: 'bottomMeasurements',
          columns: ['size','waist','hips','pantsLength'],
          rows: [
            ['S','68 cm · 26.8 in','105 cm · 41.3 in','110 cm'],['M','73 cm · 28.7 in','110 cm · 43.3 in','111 cm'],
            ['L','78 cm · 30.7 in','115 cm · 45.3 in','112 cm'],['XL','83 cm · 32.7 in','120 cm · 47.2 in','113 cm'],
            ['XXL','88 cm · 34.6 in','125 cm · 49.2 in','114 cm'],['XXXL','93 cm · 36.6 in','130 cm · 51.2 in','115 cm']
          ]
        }
      ],
      measures: ['bust','waist','hips','sleeve','length'],
      notes: []
    },
    '11178376495441': {
      key: 'elise',
      wide: true,
      columns: ['size','us','topLength','bust','shoulder','pantsLength','waist','hips'],
      rows: [
        ['S','4–6','67','85','38','92','70','100'],['M','8–10','69','90','40','94','75','105'],
        ['L','12–14','71','95','42','96','80','110'],['XL','16–18','73','100','44','98','85','115'],['XXL','20–22','75','105','46','100','90','120']
      ],
      measures: ['bust','shoulder','waist','hips','length'],
      notes: ['supplierUnitUnspecified','missingXXXLMeasurements']
    },
    '11178374660433': {
      key: 'amandine',
      wide: true,
      columns: ['size','bust','waist','hips','sleeve','topLength','bottomLength'],
      rows: [
        ['S','102 cm · 40.16 in','68 cm · 26.77 in','104 cm · 40.94 in','70 cm · 27.56 in','66 cm · 25.98 in','100 cm · 39.37 in'],
        ['M','106 cm · 41.73 in','72 cm · 28.35 in','108 cm · 42.52 in','71 cm · 27.95 in','67 cm · 26.38 in','101 cm · 39.76 in'],
        ['L','112 cm · 44.09 in','78 cm · 30.71 in','114 cm · 44.88 in','72 cm · 28.35 in','68 cm · 26.77 in','102 cm · 40.16 in'],
        ['XL','118 cm · 46.46 in','84 cm · 33.07 in','120 cm · 47.24 in','73 cm · 28.74 in','69 cm · 27.17 in','103 cm · 40.55 in'],
        ['XXL','124 cm · 48.82 in','90 cm · 35.43 in','126 cm · 49.61 in','74 cm · 29.13 in','70 cm · 27.56 in','104 cm · 40.94 in']
      ],
      measures: ['bust','waist','hips','sleeve','length'],
      notes: ['missingXXXLMeasurements']
    },
    '11118483767633': {
      key: 'rosalie',
      wide: true,
      columns: ['size','eu','us','bust','waist','hips'],
      rows: [
        ['S','36','4','80–84 cm','64–68 cm','88–92 cm'],['M','38','6','84–88 cm','68–72 cm','92–96 cm'],
        ['L','40','8','88–92 cm','72–76 cm','96–100 cm'],['XL','42','10','92–96 cm','76–80 cm','100–104 cm']
      ],
      measures: ['bust','waist','hips'],
      notes: ['manual1to3']
    },
    '11099940290897': {
      key: 'valeria',
      tables: [
        {
          titleKey: 'topMeasurements',
          columns: ['size','length','sleeve','shoulder','bust'],
          rows: [['S','58 cm · 22.8 in','38 cm · 15.0 in','83 cm · 32.7 in','138 cm · 54.3 in'],['M','59 cm · 23.2 in','39 cm · 15.4 in','84 cm · 33.1 in','142 cm · 55.9 in'],['L','60 cm · 23.6 in','40 cm · 15.7 in','85 cm · 33.5 in','146 cm · 57.5 in']]
        },
        {
          titleKey: 'bottomMeasurements',
          columns: ['size','length','waist','hips'],
          rows: [['S','103 cm · 40.6 in','66 cm · 26.0 in','102 cm · 40.2 in'],['M','104 cm · 40.9 in','70 cm · 27.6 in','106 cm · 41.7 in'],['L','105 cm · 41.3 in','74 cm · 29.1 in','110 cm · 43.3 in']]
        }
      ],
      measures: ['bust','shoulder','sleeve','waist','hips','length'],
      notes: ['chooseByChart','manual1to3']
    },
    '11094719430993': {
      key: 'noemie',
      columns: ['size','bust'],
      rows: [['S','92 cm'],['M','96 cm'],['L','100 cm'],['XL','104 cm']],
      measures: ['bust','waist','hips','length'],
      notes: ['manual1to3','chooseByChart','supplierTablesConflict']
    },
    '11119923233105': {
      key: 'amelie',
      columns: ['size','topLength','bust'],
      rows: [['S','75 cm','86 cm'],['M','77 cm','90 cm'],['L','79 cm','96 cm'],['XL','81 cm','102 cm']],
      measures: ['bust','length'],
      notes: ['manual1to3','moderateThickness','softFeel','lightElasticity','comfortFit']
    },
    '11167597887825': {
      key: 'maelys',
      columns: ['size','topLength','bust'],
      rows: [['S','80 cm','86 cm'],['M','82 cm','90 cm'],['L','84 cm','96 cm'],['XL','86 cm','102 cm']],
      measures: ['bust','length'],
      notes: ['manual1to3','moderateThickness','softFeel','lightElasticity','comfortFit']
    },
    '11153990123857': {
      key: 'coralie',
      columns: ['size','topLength','bust'],
      rows: [['S','93 cm','88 cm'],['M','94 cm','92 cm'],['L','95 cm','98 cm'],['XL','96 cm','104 cm']],
      measures: ['bust','length'],
      notes: ['manual1to3','moderateThickness','softFeel','lightElasticity','comfortFit']
    },
    '11118834057553': {
      key: 'mireille',
      columns: ['size','bust','length'],
      rows: [['S','83 cm','90 cm'],['M','87 cm','92 cm'],['L','93 cm','94 cm'],['XL','99 cm','96 cm']],
      measures: ['bust','length'],
      notes: ['manual1to3','moderateThickness','softFeel','lightElasticity','comfortFit']
    },
    '11118725169489': {
      key: 'arielle',
      columns: ['size','bust','length'],
      rows: [['S','108 cm','116 cm'],['M','112 cm','117 cm'],['L','118 cm','118.5 cm'],['1XL','124 cm','120 cm']],
      measures: ['bust','length'],
      notes: ['manual1to3','moderateThickness','softFeel','lightElasticity','comfortFit','supplierXLShownAs1XL']
    },

    // Oct 05 sizing batch — Cassandre intentionally deferred pending source reconciliation
    '11212579570001': {
      key: 'clarisse',
      columns: ['size','bust','length','sleeve'],
      rows: [
        ['S','104 cm · 40.9 in','48 cm · 18.9 in','55 cm · 21.7 in'],
        ['M','108 cm · 42.5 in','49 cm · 19.3 in','56 cm · 22.0 in'],
        ['L','112 cm · 44.1 in','50 cm · 19.7 in','57 cm · 22.4 in']
      ],
      measures: ['bust','sleeve','length'],
      notes: []
    },
    '11212606177617': {
      key: 'mathilde',
      columns: ['size','bust','length','shoulder','sleeve'],
      rows: [['One Size','90–120 cm','50 cm','52 cm','38 cm']],
      measures: ['bust','shoulder','sleeve','length'],
      notes: ['highElasticity']
    },
    '11212604440913': {
      key: 'solange',
      columns: ['size','bust','length'],
      rows: [['S','104 cm','60 cm'],['M','108 cm','61 cm'],['L','114 cm','62.5 cm'],['XL','120 cm','64 cm']],
      measures: ['bust','length'],
      notes: []
    },
    '11212596838737': {
      key: 'ameliane',
      columns: ['size','length','bust','sleeve','shoulder'],
      rows: [['One Size','50 cm · 19.70 in','104 cm · 40.98 in','46 cm · 18.12 in','51 cm · 20.09 in']],
      measures: ['bust','shoulder','sleeve','length'],
      notes: ['manual2to4']
    },
    '11212590186833': {
      key: 'eveline',
      tables: [
        {
          titleKey: 'topMeasurements',
          columns: ['size','length','sleeve','shoulder','bust'],
          rows: [
            ['S','60 cm · 23.6 in','53 cm · 20.9 in','63 cm · 24.8 in','114 cm · 44.9 in'],
            ['M','61 cm · 24.0 in','54 cm · 21.3 in','64 cm · 25.2 in','118 cm · 46.5 in'],
            ['L','62 cm · 24.4 in','55 cm · 21.7 in','65 cm · 25.6 in','122 cm · 48.0 in']
          ]
        },
        {
          titleKey: 'bottomMeasurements',
          columns: ['size','length','waist','hips'],
          rows: [
            ['S','41 cm · 16.1 in','68 cm · 26.8 in','94 cm · 37.0 in'],
            ['M','42 cm · 16.5 in','72 cm · 28.3 in','98 cm · 38.6 in'],
            ['L','43 cm · 16.9 in','76 cm · 29.9 in','102 cm · 40.2 in']
          ]
        }
      ],
      measures: ['bust','shoulder','sleeve','waist','hips','length'],
      notes: ['manual1to3']
    },
    '11212587729233': {
      key: 'beatrice',
      columns: ['size','length','bust'],
      rows: [['S','56 cm','96 cm'],['M','57 cm','100 cm'],['L','58 cm','104 cm']],
      measures: ['bust','length'],
      notes: []
    },
    '11212583928145': {
      key: 'leontine',
      wide: true,
      columns: ['size','frontLength','sideLength','bust','sleeve'],
      rows: [
        ['S','60 cm · 23.62 in','50 cm · 19.69 in','100 cm · 39.37 in','58 cm · 22.83 in'],
        ['M','61 cm · 24.02 in','51 cm · 20.08 in','104 cm · 40.94 in','59 cm · 23.23 in'],
        ['L','62 cm · 24.41 in','52 cm · 20.47 in','110 cm · 43.31 in','60 cm · 23.62 in'],
        ['XL','63 cm · 24.80 in','53 cm · 20.87 in','116 cm · 45.67 in','61 cm · 24.02 in']
      ],
      measures: ['bust','sleeve','length'],
      notes: []
    },
    '11212581863761': {
      key: 'lison',
      columns: ['size','bust','length'],
      rows: [
        ['S','100 cm · 39 in','58 cm · 23 in'],
        ['M','104 cm · 41 in','59 cm · 23 in'],
        ['L','110 cm · 43 in','60 cm · 24 in'],
        ['XL','116 cm · 46 in','61 cm · 24 in']
      ],
      measures: ['bust','length'],
      notes: ['manual3to4']
    },
    '11212577014097': {
      key: 'emilienne',
      columns: ['size','length','bust','sleeve'],
      rows: [['One Size','64 cm','80–116 cm','52 cm']],
      measures: ['bust','sleeve','length'],
      notes: ['manual2to3']
    },
    '11212593496401': {
      key: 'elodine',
      columns: ['size','length','bust','sleeve','shoulder'],
      rows: [
        ['S','84 cm','104 cm','58 cm','41 cm'],
        ['M','85 cm','108 cm','59 cm','42 cm'],
        ['L','86 cm','114 cm','60 cm','43 cm'],
        ['XL','87 cm','120 cm','61 cm','44 cm'],
        ['XXL','88 cm','126 cm','62 cm','45 cm']
      ],
      measures: ['bust','shoulder','sleeve','length'],
      notes: []
    }
  };

  const normalize = (value) => String(value || '')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[._-]+/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();

  function context() {
    const el = document.querySelector('[data-kiki-sizing-context]');
    return {
      country: String(el?.dataset.country || '').toUpperCase(),
      countryName: String(el?.dataset.countryName || ''),
      locale: String(el?.dataset.locale || document.documentElement.lang || 'en')
    };
  }

  function copy() {
    const key = context().locale.toLowerCase().split('-')[0];
    return COPY[key] || COPY.en;
  }

  function sizingSystem() {
    const country = context().country;
    if (country === 'US') return { key: 'US', label: 'US' };
    if (country === 'CA') return { key: 'US', label: 'US / CA' };
    if (country === 'GB' || country === 'IE' || country === 'SG' || country === 'MY') return { key: 'UK', label: 'UK' };
    if (country === 'AU') return { key: 'AU', label: 'AU' };
    if (country === 'NZ') return { key: 'AU', label: 'AU / NZ' };
    if (country === 'BR') return { key: 'BR', label: 'BR' };
    return { key: 'EU', label: 'EU' };
  }

  function sourceSize(input) {
    const value = String(input?.value || '').trim();
    return Object.prototype.hasOwnProperty.call(CONVERSIONS, value) ? value : null;
  }

  function headingText(picker) {
    const heading = picker.querySelector(':scope > .pp-text-sm');
    if (!heading) return '';
    const label = heading.querySelector('.kiki-size-heading__label');
    return (label?.textContent || heading.dataset.kikiBaseHeading || heading.textContent || '').split(':')[0].trim();
  }

  function isShoePicker(picker) {
    const first = picker.querySelector('input[type="radio"]');
    const inputName = normalize(first?.name || '');
    if (inputName.includes('shoe size') || inputName.includes('pointure') || inputName.includes('schuh')) return true;
    return SHOE_OPTION_NAMES.has(normalize(headingText(picker)));
  }

  function isApparelSizePicker(picker) {
    if (isShoePicker(picker)) return false;
    const first = picker.querySelector('input[type="radio"]');
    const inputName = normalize(first?.name || '');
    const head = normalize(headingText(picker));
    return inputName.startsWith('size ') || inputName === 'size' || ['size','tamanho','tamano','talla','taille','grosse','größe','groesse','taglia'].includes(head);
  }

  function setShoeHeading(picker, system) {
    const t = copy();
    const heading = picker.querySelector(':scope > .pp-text-sm');
    if (!heading) return;
    const label = heading.querySelector('.kiki-size-heading__label');
    const text = `${t.shoeHeading} (${system.label})`;
    if (label) label.textContent = text;
    else if (!heading.querySelector('.kiki-size-guide-button')) heading.textContent = text;
  }

  function sortShoeChoices(picker) {
    const row = picker.querySelector(':scope > .pp-flex.pp-flex-wrap');
    if (!row || row.dataset.kikiSizeSorted === 'true') return;
    const children = Array.from(row.children);
    if (!children.length) return;
    const sortable = children.every((wrapper) => sourceSize(wrapper.querySelector('input[type="radio"]')));
    if (!sortable) return;
    children
      .sort((a, b) => Number(sourceSize(a.querySelector('input[type="radio"]'))) - Number(sourceSize(b.querySelector('input[type="radio"]'))))
      .forEach((node) => row.appendChild(node));
    row.dataset.kikiSizeSorted = 'true';
  }

  function decorateShoePicker(picker) {
    if (!isShoePicker(picker)) return;
    const system = sizingSystem();
    setShoeHeading(picker, system);
    sortShoeChoices(picker);

    picker.querySelectorAll('input[type="radio"]').forEach((input) => {
      const eu = sourceSize(input);
      if (!eu) return;
      const local = system.key === 'EU' ? eu : (CONVERSIONS[eu]?.[system.key] || eu);
      const label = picker.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      if (!label) return;
      label.dataset.kikiSourceSize = eu;
      label.dataset.kikiLocalSize = local;
      label.textContent = local;
      label.title = system.key === 'EU' ? `EU ${eu}` : `${system.label} ${local} · EU ${eu}`;
      input.setAttribute('aria-label', label.title);
    });
    picker.dataset.kikiSizingSystem = system.label;
  }

  function decorate(root = document) {
    root.querySelectorAll?.('.pagepilot-main-product .pp-variant-picker').forEach((picker) => {
      if (isShoePicker(picker)) decorateShoePicker(picker);
    });
  }

  let oldOverflow = '';
  let returnFocus = null;

  function closeGuide() {
    const modal = document.getElementById('kiki-market-size-guide-modal');
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.style.overflow = oldOverflow;
    if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
    returnFocus = null;
  }

  function ensureModal() {
    let modal = document.getElementById('kiki-market-size-guide-modal');
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = 'kiki-market-size-guide-modal';
    modal.className = 'kiki-market-size-modal';
    modal.hidden = true;
    modal.innerHTML = `
      <div class="kiki-market-size-modal__backdrop" data-kiki-market-size-close></div>
      <section class="kiki-market-size-modal__panel" role="dialog" aria-modal="true" aria-labelledby="kiki-market-size-title">
        <button class="kiki-market-size-modal__close" type="button" data-kiki-market-size-close aria-label="Close">×</button>
        <div class="kiki-market-size-modal__body"></div>
      </section>`;
    document.body.appendChild(modal);
    modal.querySelectorAll('[data-kiki-market-size-close]').forEach((el) => el.addEventListener('click', closeGuide));
    return modal;
  }

  const esc = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[char]));

  function productIdFromPicker(picker) {
    const root = picker.closest('product-info[data-product-id]');
    return String(root?.dataset.productId || '');
  }

  function productSizeCopy() {
    const key = context().locale.toLowerCase().split('-')[0];
    return PRODUCT_SIZE_COPY[key] || PRODUCT_SIZE_COPY.en;
  }

  function renderProductChart(productId) {
    const guide = PRODUCT_SIZE_GUIDES[productId];
    if (!guide) return '';
    const p = productSizeCopy();

    const renderTable = (table, showTitle = false) => {
      const head = table.columns.map((key) => `<th scope="col">${esc(p[key] || key)}</th>`).join('');
      const rows = table.rows.map((row) =>
        `<tr>${row.map((value, index) => index === 0 ? `<td><strong>${esc(value)}</strong></td>` : `<td>${esc(value)}</td>`).join('')}</tr>`
      ).join('');
      return `
        <div class="kiki-market-product-subtable">
          ${showTitle ? `<h4>${esc(p[table.titleKey] || p.chart)}</h4>` : ''}
          <div class="kiki-market-size-table-wrap kiki-market-product-table-wrap">
            <table class="kiki-market-size-table kiki-market-product-table${table.wide ? ' is-wide' : ''}">
              <thead><tr>${head}</tr></thead>
              <tbody>${rows}</tbody>
            </table>
          </div>
        </div>`;
    };

    let tables = '';
    if (Array.isArray(guide.tables)) {
      tables = guide.tables.map((table) => renderTable(table, true)).join('');
    } else if (guide.columns?.length && guide.rows?.length) {
      tables = renderTable(guide, false);
    }

    const general = guide.general?.length
      ? `<div class="kiki-market-product-general"><h3>${esc(p.supplier)}</h3><dl>${guide.general.map(([key,value]) => `<div><dt>${esc(p[key] || key)}</dt><dd>${esc(value)}</dd></div>`).join('')}</dl></div>`
      : '';

    return `
      <section class="kiki-market-size-modal__section kiki-market-product-chart" data-kiki-product-size-chart="${esc(guide.key)}">
        <h3>${esc(p[guide.titleKey] || p.chart)}</h3>
        ${tables}
        ${general}
      </section>`;
  }

  function productMeasureHtml(productId, t) {
    const guide = PRODUCT_SIZE_GUIDES[productId];
    if (!guide) return '';
    const p = productSizeCopy();
    const values = {
      bust: t.bust,
      waist: t.waist,
      hips: t.hips,
      shoulder: p.shoulderMeasure,
      sleeve: p.sleeveMeasure,
      length: p.lengthMeasure
    };
    return `<ul class="kiki-market-size-steps">${guide.measures.map((key) => `<li>${esc(values[key] || key)}</li>`).join('')}</ul>`;
  }

  function productNote(productId, fallback) {
    const guide = PRODUCT_SIZE_GUIDES[productId];
    if (!guide) return fallback;
    const p = productSizeCopy();
    if (Array.isArray(guide.notes)) {
      const notes = guide.notes.map((key) => p[key]).filter(Boolean);
      return notes.length ? notes.join(' ') : fallback;
    }
    return p[guide.noteKey] || fallback;
  }

  function entries(picker) {
    const out = [];
    const seen = new Set();
    picker.querySelectorAll('input[type="radio"]').forEach((input) => {
      const eu = sourceSize(input);
      const raw = String(input.value || '').trim();
      const key = eu || raw;
      if (!key || seen.has(key)) return;
      seen.add(key);
      out.push({ input, eu, raw });
    });
    if (out.every((entry) => entry.eu)) out.sort((a, b) => Number(a.eu) - Number(b.eu));
    return out;
  }

  function measurementStep(t) {
    const imperialFirst = ['US','CA'].includes(context().country);
    return imperialFirst ? t.step2Imperial : t.step2Metric;
  }

  function openGuide(picker, button) {
    const t = copy();
    const ctx = context();
    const system = sizingSystem();
    const shoe = isShoePicker(picker);
    const items = entries(picker);
    const productId = productIdFromPicker(picker);
    const productGuide = PRODUCT_SIZE_GUIDES[productId] || null;
    const modal = ensureModal();
    const closeButton = modal.querySelector('.kiki-market-size-modal__close');
    closeButton.setAttribute('aria-label', t.close);

    let sizesHtml = '';
    if (shoe && items.some((item) => item.eu)) {
      const rows = items.map((item) => {
        const eu = item.eu || item.raw;
        const local = item.eu && system.key !== 'EU' ? (CONVERSIONS[item.eu]?.[system.key] || item.raw) : item.raw;
        const selected = item.input.checked ? ' class="is-selected"' : '';
        if (system.key === 'EU') {
          return `<tr${selected}><td><strong>${esc(local)}</strong></td></tr>`;
        }
        return `<tr${selected}><td><strong>${esc(local)}</strong></td><td>EU ${esc(eu)}</td></tr>`;
      }).join('');
      sizesHtml = system.key === 'EU'
        ? `<div class="kiki-market-size-table-wrap"><table class="kiki-market-size-table"><thead><tr><th>${esc(t.yourSize)} · EU</th></tr></thead><tbody>${rows}</tbody></table></div>`
        : `<div class="kiki-market-size-table-wrap"><table class="kiki-market-size-table"><thead><tr><th>${esc(t.yourSize)} · ${esc(system.label)}</th><th>${esc(t.supplierSize)}</th></tr></thead><tbody>${rows}</tbody></table></div>`;
    } else {
      const chips = items.map((item) => `<span class="kiki-market-size-chip${item.input.checked ? ' is-selected' : ''}">${esc(item.raw)}</span>`).join('');
      sizesHtml = `<div class="kiki-market-size-chips">${chips}</div>`;
    }

    const measureHtml = shoe
      ? `<ol class="kiki-market-size-steps"><li>${esc(t.step1)}</li><li>${esc(measurementStep(t))}</li><li>${esc(t.step3)}</li></ol>`
      : (productGuide ? productMeasureHtml(productId, t) : `<ul class="kiki-market-size-steps"><li>${esc(t.bust)}</li><li>${esc(t.waist)}</li><li>${esc(t.hips)}</li></ul>`);

    const productChartHtml = !shoe && productGuide ? renderProductChart(productId) : '';
    const note = shoe ? t.shoeNote : productNote(productId, t.apparelNote);

    modal.querySelector('.kiki-market-size-modal__body').innerHTML = `
      <header class="kiki-market-size-modal__header">
        <p class="kiki-market-size-modal__eyebrow">${esc(t.marketFor)} ${esc(ctx.countryName || ctx.country)} · ${esc(system.label)}</p>
        <h2 id="kiki-market-size-title">${esc(t.guide)}</h2>
        ${shoe ? `<p class="kiki-market-size-modal__intro">${esc(t.localHint)}</p>` : ''}
      </header>
      <section class="kiki-market-size-modal__section">
        <h3>${esc(t.available)}</h3>
        ${sizesHtml}
      </section>
      ${productChartHtml}
      <div class="kiki-market-size-modal__grid">
        <section class="kiki-market-size-modal__section">
          <h3>${esc(t.how)}</h3>
          ${measureHtml}
        </section>
        <aside class="kiki-market-size-note">
          <h3>${esc(t.fitTitle)}</h3>
          <p>${esc(note)}</p>
        </aside>
      </div>`;

    oldOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    returnFocus = button;
    modal.hidden = false;
    closeButton.focus({ preventScroll: true });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('.kiki-size-guide-button');
    if (!button) return;
    const picker = button.closest('.pp-variant-picker');
    if (!picker) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openGuide(picker, button);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeGuide();
  });

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      decorate(document);
    });
  };

  const boot = () => {
    decorate(document);
    [100, 350, 900, 1800].forEach((delay) => setTimeout(schedule, delay));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('pageshow', boot);
})();